// extracted by mini-css-extract-plugin
export default {"testingMode":"testingMode__GzUbzc"};